<div class="d-flex justify-content-between align-items-center">
  <h2>{{title}}</h2>
  <div class="d-flex justify-content-between gap-2 page-btns">
    @for (btn of btnList; track btn) {
      <ap-button [btnType]="btn.type || ''" [icon]="btn.icon || ''"
      [label]="btn.label || ''" (onClick)="onClick(btn.action)"></ap-button>
    }
  </div>
</div>